import VueRouter from 'vue-router'

import routes from './routes'
import store from '@/store'

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.params.forced) {
    return next()
  }

  let [auth] = to.matched.filter((match) => {
    return match.meta && match.meta.auth
  })

  if (auth) {
    let { authenticated } = store.getters

    if (!authenticated) {
      return router.push({ name: 'login' })
    }
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js